import getApi from "../api/getApi";
import postApi from "../api/postApi";
import * as url from "../api/url";

export const getCompanyById = (companyID, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(`${url.GET_COMPANY_BY_ID}?companyId=${companyID}`, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getCompanyType = (header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(`${url.GET_COMPANY_TYPE}`, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getIndustriesType = (header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(`${url.GET_INDUSTRIES}`, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const DummyAPICall = (header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(`${url.DUMMY_API_CALL}`, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const companyNameCheck = (query, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(`${url.CHECK_COMPANY_NAME}${query}`, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const saveCompanyInfo = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return postApi
      .post(`${url.SAVE_COMPANY}`, payload, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const sendEmail = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return postApi
      .post(`${url.SEND_EMAIL}`, payload, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};
